import { useEffect } from 'react'
import { Box } from '@holbonkit/ui'
import { useSearch } from '@tanstack/react-router'

import styles from './redirect.module.scss'

export const RedirectPage = () => {
    const { redirectUrl, state } = useSearch({
        from: '/redirect',
    })

    useEffect(() => {
        switch (redirectUrl) {
            case 'driver-recharge-success': {
                globalThis.location.href =
                    'drivee://web?url=' + globalThis.location.origin + '/driver-recharge/success'
                break
            }
            case 'driver-recharge-error': {
                globalThis.location.href =
                    'drivee://web?url=' + globalThis.location.origin + '/driver-recharge/error'
                break
            }
            default: {
                globalThis.location.href =
                    'drivee://web?url=' + globalThis.location.origin + '/driver-recharge'
                break
            }
        }
    }, [redirectUrl, state])

    return (
        <Box className={styles.redirect}>
            <h1>Redirecting...</h1>
        </Box>
    )
}
